<div>
  @if (!showDropdownFilter) {
    <div class="container">
      @if (!isInEditMode) {
        <button
          class="more"
          [class.binary]="isBinary"
          [class.is-binary-filter-active]="isBinaryFilterActive"
          (click)="toggleEditMode()">
          <ng-container *ngTemplateOutlet="informationTag"></ng-container>
        </button>
      }
      @if (isInEditMode) {
        <div>
          @switch (tag()?.type) {
            @case (listViewFilterTagType.Input) {
              <coin-v2-text-input
                #textInput
                size="small"
                [placeholder]="tag()?.title | translate"
                [(ngModel)]="inputText"
                (focusout)="submitTextInput()"
                (keyup.enter)="submitTextInput()" />
            }
            @case (listViewFilterTagType.Date) {
              <coin-v2-date-input
                [placeholder]="'general.click-to-select' | translate"
                [formControl]="dateFormControl" />
            }
            @case (listViewFilterTagType.DateRange) {
              <coin-v2-date-range-input
                [startPlaceholder]="'general.start-date' | translate"
                [endPlaceholder]="'general.end-date' | translate"
                [formControl]="dateRangeFormControl"
                (closed)="onDateRangePickerClosed()" />
            }
          }
        </div>
      }
    </div>
  }

  @if (showDropdownFilter) {
    <div class="container">
      <button
        class="more"
        [matMenuTriggerFor]="filterActions">
        <ng-container *ngTemplateOutlet="informationTag"></ng-container>
      </button>
      <mat-menu
        #filterActions="matMenu"
        class="filter-tag-options">
        @if (!!tag()?.subFilters?.length) {
          @for (filter of tag().subFilters; track filter.title) {
            <button
              class="text"
              mat-menu-item
              [class.selected]="isSelected(filter)"
              (click)="onFilterClicked(filter)">
              <div class="support-state-filter-item">
                <p>{{ filter?.title | translate }}</p>
                @if (!hideCount()) {
                  <p>{{ filter?.count }}</p>
                }
              </div>
            </button>
          }
        }
      </mat-menu>
    </div>
  }
</div>

<ng-template #informationTag>
  <coin-v2-dual-pill
    size="large"
    [contentLeft]="tag()?.title | translate"
    [textRight]="tagValue | translate"
    [icon]="tag()?.icon"
    [svgIcon]="tag()?.svgIcon"
    [themeColor]="$any(tag()?.color)"></coin-v2-dual-pill>
</ng-template>
